import { useState } from 'react';
import './ImageCarousel.css';

interface CarouselImageProps {
  src?: string;
  alt: string;
  className?: string;
  fit?: 'cover' | 'contain';
  loading?: 'eager' | 'lazy';
}

interface ImageLoadState {
  source?: string;
  fallback: boolean;
  loaded: boolean;
  unavailable: boolean;
}

const fallbackImage = '/app-images/not-found-image/place_holder_image.png';

const CarouselImage = ({ src, alt, className = '', fit = 'contain', loading }: CarouselImageProps) => {
  const [state, setState] = useState<ImageLoadState>({ source: src, fallback: false, loaded: false, unavailable: false });
  const currentSource = state.source === src;
  const fallback = !src || (currentSource && state.fallback);
  const loaded = currentSource && state.loaded;
  const unavailable = currentSource && state.unavailable;

  return (
    <span className="ss-carousel-image" data-loading={!loaded && !unavailable} aria-busy={!loaded && !unavailable}>
      {!loaded && !unavailable && <span className="ss-carousel-image__spinner" aria-hidden="true" />}
      {unavailable ? <span className="ss-carousel-image__unavailable" role="img" aria-label={alt}>Photo unavailable</span> : <img
        key={src}
        className={`ss-carousel-image__image ${className}`}
        src={fallback ? fallbackImage : src}
        alt={alt}
        style={{ objectFit: fallback ? 'contain' : fit }}
        data-loaded={loaded}
        loading={loading}
        draggable={false}
        onLoad={() => setState({ source: src, fallback, loaded: true, unavailable: false })}
        onError={() => setState({ source: src, fallback: true, loaded: fallback, unavailable: fallback })}
      />}
    </span>
  );
};

export default CarouselImage;
